document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('a[href^="http"]').forEach(link => {
    if (link.hostname !== window.location.hostname) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });

  function initSliderProgressBars() {
    const counters = document.querySelectorAll('.slider-counter:not(.is-initialized)');

    counters.forEach(counter => {
      counter.classList.add('is-initialized');
      counter.classList.add('has-progress-bar');
      
      const currentSpan = counter.querySelector('.slider-counter--current');
      const totalSpan = counter.querySelector('.slider-counter--total');

      if (!currentSpan || !totalSpan) return;

      if (!counter.querySelector('.slider-progress-track')) {
        const track = document.createElement('div');
        track.className = 'slider-progress-track';
        const fill = document.createElement('div');
        fill.className = 'slider-progress-fill';
        track.appendChild(fill);
        counter.appendChild(track);
      }
      
      const fill = counter.querySelector('.slider-progress-fill');

      const updateProgressBar = () => {
        const current = parseInt(currentSpan.textContent.trim(), 10) || 1;
        const total = parseInt(totalSpan.textContent.trim(), 10) || 1; 
        
        const percentage = (current / total) * 100;
        fill.style.width = `${percentage}%`;
      };

      updateProgressBar();

      const observer = new MutationObserver(updateProgressBar);
      const config = { characterData: true, subtree: true, childList: true };
      observer.observe(currentSpan, config);
      observer.observe(totalSpan, config);
    });
  }

  function initDesktopSliderDrag() {

    const sliders = document.querySelectorAll('slider-component .slider:not(.drag-initialized)');

    sliders.forEach((slider) => {
      slider.classList.add('drag-initialized');
      
      let isDown = false;
      let isDragging = false;
      let startX;
      let scrollLeft;

      slider.style.cursor = 'grab';

      slider.addEventListener('mousedown', (e) => {
        isDown = true;
        isDragging = false;
        slider.style.cursor = 'grabbing';
        
        slider.style.scrollSnapType = 'none';
        slider.style.scrollBehavior = 'auto'; 
        
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });

      slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.style.cursor = 'grab';
        slider.style.scrollSnapType = ''; 
        slider.style.scrollBehavior = ''; 
      });

      slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.style.cursor = 'grab';
        slider.style.scrollSnapType = ''; 
        slider.style.scrollBehavior = ''; 
      });

      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault(); 
        isDragging = true;
        
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 1.5; 
        slider.scrollLeft = scrollLeft - walk;
      });

      slider.addEventListener('click', (e) => {
        if (isDragging) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    });
  }

  initSliderProgressBars();
  initDesktopSliderDrag();

  const dynamicContentObserver = new MutationObserver((mutations) => {
    let shouldReinit = false;
    
    mutations.forEach(mutation => {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1 && (node.matches('slider-component, product-recommendations') || node.querySelector('slider-component'))) {
            shouldReinit = true;
          }
        });
      }
    });

    if (shouldReinit) {
      initSliderProgressBars();
      initDesktopSliderDrag();
    }
  });

  dynamicContentObserver.observe(document.body, { childList: true, subtree: true });

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
          const targetId = this.getAttribute('href');
          if (targetId === '#') return;

          const targetElement = document.querySelector(targetId);

          if (targetElement) {
              e.preventDefault();

              const header = document.querySelector('.header-wrapper') || document.querySelector('sticky-header');
              const offset = header ? header.offsetHeight : 100;

              const elementPosition = targetElement.getBoundingClientRect().top;
              const offsetPosition = elementPosition + window.pageYOffset - offset;

              window.scrollTo({
                  top: offsetPosition,
                  behavior: "smooth"
              });
          }
      });
  });

  if (!window.CardQuantitySynced) {
    window.CardQuantitySynced = true;
    
    document.addEventListener('change', function(event) {
      if (event.target.matches('.card-quantity-wrapper .quantity__input')) {
        const form = event.target.closest('form');
        
        if (form) {
          const hiddenInput = form.querySelector('input[name="quantity"][type="hidden"]');
          if (hiddenInput) {
            hiddenInput.value = event.target.value;
          }
        }
      }
    });

    document.querySelectorAll('.card-quantity-wrapper .quantity__input').forEach(input => {
      if (input.value === "0" || input.value === "") input.value = "1";
    });
  }

  // Klaviyo dropdowns (e.g. the SMS form's country picker) close on blur when
  // focus moves outside the form. Dawn's <main id="MainContent" tabindex="-1">
  // is focusable, so pressing an option moved focus there and closed the list
  // before the click could select it. Keep focus in the search input instead.
  document.addEventListener('mousedown', function(event) {
    if (event.target.closest('.klaviyo-form [role="listbox"]')) {
      event.preventDefault();
    }
  }, true);

});